(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.acReady === '1') return;
      root.dataset.acReady = '1';

      var track = root.querySelector('[data-ac-track]');
      if (!track) return;
      var prev = root.querySelector('[data-ac-prev]');
      var next = root.querySelector('[data-ac-next]');

      function stepSize() {
        var slide = track.querySelector('[data-ac-slide]');
        if (!slide) return track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (prev) prev.disabled = x <= 1;
        if (next) next.disabled = x >= max - 1;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: stepSize(), behavior: 'smooth' });
        });
      }

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          update();
        });
      }, { passive: true });

      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ac-carousel]').forEach(initCarousel);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    // Theme editor: re-init when a section is (re)loaded
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function switchTab(root, index) {
      root.querySelectorAll('[data-about-faq-pill]').forEach(function (pill) {
        var active = pill.getAttribute('data-about-faq-pill') === index;
        pill.classList.toggle('is-active', active);
        pill.classList.toggle('color-scheme-3', active);
        pill.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-about-faq-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-about-faq-panel') === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function syncRoot(root) {
      var current = root.querySelector('[data-about-faq-pill].is-active');
      var index = current ? current.getAttribute('data-about-faq-pill') : '0';
      switchTab(root, index);
    }

    function syncAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-about-faq]');
      roots.forEach(syncRoot);
    }

    // Delegated click — bound once, so re-injecting this block stays idempotent.
    if (!window.__aboutFaqBound) {
      window.__aboutFaqBound = true;
      document.addEventListener('click', function (event) {
        var pill = event.target.closest('[data-about-faq-pill]');
        if (!pill) return;
        var root = pill.closest('[data-about-faq]');
        if (!root) return;
        switchTab(root, pill.getAttribute('data-about-faq-pill'));
      });

      // Theme editor: keep the active panel in sync when a section (re)loads.
      document.addEventListener('shopify:section:load', function (event) {
        syncAll(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { syncAll(); });
    } else {
      syncAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-image-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.aitReady === '1') return;
      root.dataset.aitReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ait-slide]'));
      if (slides.length < 2) return;

      var index = 0;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === 0);
      });

      function go(to) {
        index = (to + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
      }

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-ait-prev]')) {
          go(index - 1);
        } else if (event.target.closest('[data-ait-next]')) {
          go(index + 1);
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ait-carousel]').forEach(initCarousel);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    // Theme editor: re-init when a section is (re)loaded
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTeam(root) {
      if (root.dataset.aboutTeamInit === 'true') return;
      root.dataset.aboutTeamInit = 'true';

      /* ---- Carousel ---- */
      var viewport = root.querySelector('[data-about-team-viewport]');
      var track = root.querySelector('[data-about-team-track]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-about-team-slide]')) : [];
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-about-team-dot]'));
      var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-about-team-arrow]'));

      function stride() {
        if (slides.length < 2) return viewport ? viewport.clientWidth : 0;
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      }
      function clamp(i) {
        return Math.max(0, Math.min(slides.length - 1, i));
      }
      function activeIndex() {
        var s = stride();
        if (!viewport || !s) return 0;
        return clamp(Math.round(viewport.scrollLeft / s));
      }
      function setActive(i) {
        dots.forEach(function (dot, di) {
          var on = di === i;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      function goTo(i) {
        if (!viewport) return;
        viewport.scrollTo({ left: clamp(i) * stride(), behavior: 'smooth' });
      }

      if (viewport && slides.length > 1) {
        var ticking = false;
        viewport.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            setActive(activeIndex());
          });
        });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.getAttribute('data-about-team-dot'), 10) || 0);
          });
        });
        arrows.forEach(function (arrow) {
          arrow.addEventListener('click', function () {
            var dir = arrow.getAttribute('data-about-team-arrow') === 'prev' ? -1 : 1;
            goTo(activeIndex() + dir);
          });
        });
        setActive(0);
      }

      /* ---- Detail pop-ups ---- */
      var dialogs = Array.prototype.slice.call(root.querySelectorAll('[data-about-team-dialog]'));
      if (!dialogs.length) return;

      function openAt(index) {
        var dialog = dialogs[index];
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      root.querySelectorAll('[data-about-team-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openAt(parseInt(btn.getAttribute('data-about-team-open'), 10) || 0);
        });
      });

      dialogs.forEach(function (dialog, index) {
        dialog.querySelectorAll('[data-about-team-close]').forEach(function (btn) {
          btn.addEventListener('click', function () { dialog.close(); });
        });
        var prev = dialog.querySelector('[data-about-team-prev]');
        var next = dialog.querySelector('[data-about-team-next]');
        if (prev) prev.addEventListener('click', function () {
          dialog.close();
          openAt((index - 1 + dialogs.length) % dialogs.length);
        });
        if (next) next.addEventListener('click', function () {
          dialog.close();
          openAt((index + 1) % dialogs.length);
        });
        // Close when clicking the backdrop (outside the paper card)
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) dialog.close();
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-about-team]').forEach(initTeam);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-announcement-dismissible]').forEach(function (el) {
    var inEditor = window.Shopify && window.Shopify.designMode;
    var key = 'announcement-dismissed-' + el.dataset.announcementKey;
    try {
      if (!inEditor && sessionStorage.getItem(key)) {
        el.hidden = true;
        return;
      }
    } catch (e) {}

    var close = el.querySelector('.announcement-bar__close');
    if (!close) return;

    close.addEventListener('click', function () {
      el.hidden = true;
      try {
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-ks-faq-pill]');
    if (pill) {
      var root = pill.closest('[data-ks-faq]');
      if (!root) return;
      var index = pill.getAttribute('data-ks-faq-pill');

      root.querySelectorAll('[data-ks-faq-pill]').forEach(function (button) {
        var active = button.getAttribute('data-ks-faq-pill') === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-ks-faq-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-ks-faq-panel') === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      return;
    }

    var top = event.target.closest('[data-ks-faq-top]');
    if (top) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ProductReviewsSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.hideWhenEmpty !== 'true' || !this.hidden) return;
      this.reveal = this.reveal.bind(this);
      this.observer = new MutationObserver(this.reveal);
      this.observer.observe(this, { childList: true, subtree: true });
      this.reveal();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    reveal() {
      // The WebwinkelKeur block renders one .valued-review-body per review.
      if (!this.querySelector('.valued-review-body')) return;
      this.hidden = false;
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('product-reviews-section')) {
    customElements.define('product-reviews-section', ProductReviewsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator-map"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('store-locator')) return;

    const MAPBOX_VERSION = '3.9.0';
    let mapboxPromise = null;

    function loadMapbox() {
      if (mapboxPromise) return mapboxPromise;
      mapboxPromise = new Promise((resolve, reject) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = `https://api.mapbox.com/mapbox-gl-js/v${MAPBOX_VERSION}/mapbox-gl.css`;
        document.head.appendChild(css);
        const script = document.createElement('script');
        script.src = `https://api.mapbox.com/mapbox-gl-js/v${MAPBOX_VERSION}/mapbox-gl.js`;
        script.onload = () => resolve(window.mapboxgl);
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return mapboxPromise;
    }

    function haversineKm(a, b) {
      const rad = (d) => (d * Math.PI) / 180;
      const R = 6371;
      const dLat = rad(b.lat - a.lat);
      const dLng = rad(b.lng - a.lng);
      const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(h));
    }

    class StoreLocator extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.stores = this.config.stores
          .map((s, index) => ({ ...s, index, lat: parseFloat(s.lat), lng: parseFloat(s.lng) }))
          .filter((s) => Number.isFinite(s.lat) && Number.isFinite(s.lng));
        this.listEl = this.querySelector('[data-list]');
        this.mapEl = this.querySelector('[data-map]');
        this.statusEl = this.querySelector('[data-status]');
        this.cards = Array.from(this.querySelectorAll('.store-card'));
        this.markers = [];
        this.map = null;

        this.bindSearch();
        this.bindCards();
        this.setStatus(this.config.strings.storesCount.replace('[count]', String(this.stores.length)));

        if (!this.config.token) {
          this.classList.add('slm--no-token');
          return;
        }

        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              io.disconnect();
              this.initMap();
            }
          });
        });
        io.observe(this);
      }

      async initMap() {
        if (this.map || !this.config.token || !this.mapEl) return;
        let mapboxgl;
        try {
          mapboxgl = await loadMapbox();
        } catch (e) {
          this.classList.add('slm--no-token');
          return;
        }
        mapboxgl.accessToken = this.config.token;

        try {
          this.map = new mapboxgl.Map({
            container: this.mapEl,
            style: this.config.mapStyle,
            center: [5.2913, 52.1326],
            zoom: 6.5,
            cooperativeGestures: true,
            attributionControl: { compact: true },
          });
        } catch (e) {
          console.error('[store-locator] Map init failed:', e);
          this.classList.add('slm--no-token');
          return;
        }
        this.map.on('error', (e) => {
          // Surface token/style failures instead of a silently empty map
          console.error('[store-locator] Mapbox error:', e.error && e.error.message);
          if (e.error && /(401|403|Unauthorized|Forbidden)/i.test(String(e.error.message))) {
            this.classList.add('slm--no-token');
          }
        });
        this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

        this.stores.forEach((store) => {
          const el = document.createElement('div');
          el.className = 'slm-marker';
          el.setAttribute('role', 'button');
          el.setAttribute('aria-label', store.name || '');

          const popup = new mapboxgl.Popup({ offset: 28, closeButton: false }).setDOMContent(
            this.buildPopup(store)
          );

          const marker = new mapboxgl.Marker({ element: el, anchor: 'bottom' })
            .setLngLat([store.lng, store.lat])
            .setPopup(popup)
            .addTo(this.map);

          el.addEventListener('click', () => this.activate(store.index, { scrollList: true }));
          this.markers[store.index] = marker;
        });

        this.fitAll();

        new ResizeObserver(() => {
          if (this.map) this.map.resize();
        }).observe(this.mapEl);
      }

      buildPopup(store) {
        const root = document.createElement('div');
        root.className = 'slm-popup';
        const name = document.createElement('strong');
        name.textContent = store.name || '';
        root.appendChild(name);
        if (store.address) {
          store.address.split('\n').forEach((line) => {
            const div = document.createElement('div');
            div.textContent = line;
            root.appendChild(div);
          });
        }
        const link = document.createElement('a');
        link.href = `https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = this.config.strings.getDirections;
        root.appendChild(link);
        return root;
      }

      fitAll() {
        if (!this.map || !this.stores.length) return;
        // Fit the main cluster only; far outliers (e.g. Curaçao) would zoom the
        // initial view out to a world map.
        const median = (values) => {
          const sorted = [...values].sort((a, b) => a - b);
          return sorted[Math.floor(sorted.length / 2)];
        };
        const center = {
          lat: median(this.stores.map((s) => s.lat)),
          lng: median(this.stores.map((s) => s.lng)),
        };
        let cluster = this.stores.filter((s) => haversineKm(center, s) < 1500);
        if (!cluster.length) cluster = this.stores;
        const bounds = new window.mapboxgl.LngLatBounds(
          [cluster[0].lng, cluster[0].lat],
          [cluster[0].lng, cluster[0].lat]
        );
        cluster.forEach((s) => bounds.extend([s.lng, s.lat]));
        this.map.fitBounds(bounds, { padding: 70, maxZoom: 12, duration: 0 });
      }

      bindCards() {
        this.cards.forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a, summary, details')) return;
            this.activate(Number(card.dataset.storeIndex), { flyTo: true });
          });
        });
      }

      bindSearch() {
        const form = this.querySelector('[data-search-form]');
        const locate = this.querySelector('[data-geolocate]');

        if (form) {
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            const q = form.q.value.trim();
            if (!q) return;
            if (!this.config.token) {
              this.setStatus(this.config.strings.noResults);
              return;
            }
            try {
              const url =
                'https://api.mapbox.com/search/geocode/v6/forward' +
                `?q=${encodeURIComponent(q)}` +
                `&country=${encodeURIComponent(this.config.countries)}` +
                '&limit=1&language=nl&proximity=5.2913,52.1326' +
                `&access_token=${this.config.token}`;
              const res = await fetch(url);
              const data = await res.json();
              const feature = data.features && data.features[0];
              if (!feature) {
                this.setStatus(this.config.strings.noResults);
                return;
              }
              const [lng, lat] = feature.geometry.coordinates;
              this.setOrigin({ lat, lng });
            } catch (e) {
              this.setStatus(this.config.strings.noResults);
            }
          });
        }

        if (locate) {
          locate.addEventListener('click', () => {
            if (!navigator.geolocation) return;
            navigator.geolocation.getCurrentPosition(
              (pos) => this.setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
              () => this.setStatus(this.config.strings.noResults)
            );
          });
        }
      }

      setOrigin(origin) {
        this.origin = origin;
        const sorted = [...this.stores].sort(
          (a, b) => haversineKm(origin, a) - haversineKm(origin, b)
        );
        sorted.forEach((store) => {
          const card = this.cards[store.index];
          if (!card) return;
          const badge = card.querySelector('[data-distance]');
          if (badge) {
            badge.hidden = false;
            badge.textContent = this.config.strings.distanceKm.replace(
              '[distance]',
              haversineKm(origin, store).toFixed(1)
            );
          }
          this.listEl.appendChild(card);
        });
        this.setStatus(this.config.strings.closestFirst);

        const nearest = sorted[0];
        if (nearest) this.activate(nearest.index, { flyTo: true, scrollList: true });
        if (this.map) {
          const bounds = new window.mapboxgl.LngLatBounds(
            [origin.lng, origin.lat],
            [origin.lng, origin.lat]
          );
          if (nearest) bounds.extend([nearest.lng, nearest.lat]);
          this.map.fitBounds(bounds, { padding: 90, maxZoom: 12 });
        }
      }

      activate(index, options = {}) {
        this.cards.forEach((card) => {
          card.classList.toggle('is-active', Number(card.dataset.storeIndex) === index);
        });
        this.markers.forEach((marker, i) => {
          if (!marker) return;
          marker.getElement().classList.toggle('is-active', i === index);
          if (i === index) {
            if (!marker.getPopup().isOpen()) marker.togglePopup();
          } else if (marker.getPopup().isOpen()) {
            marker.togglePopup();
          }
        });
        const store = this.stores.find((s) => s.index === index);
        if (store && this.map && options.flyTo) {
          this.map.flyTo({ center: [store.lng, store.lat], zoom: Math.max(this.map.getZoom(), 11) });
        }
        if (options.scrollList) {
          const card = this.cards[index];
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      setStatus(text) {
        if (this.statusEl) this.statusEl.textContent = text;
      }
    }

    customElements.define('store-locator', StoreLocator);
  })();

  } catch(e) { console.error(e); }
})();
})();
